import moment from 'moment';
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import systemApi from '@/services/system.services';

  export default {
    name: "GlobalSystems",
    data() {
      return {
        controller: {
          title: "T. Información",
          mainRouter: "/tinformacion/sistemas"      
        },
        loading: false,
        user: Auth.getUser(),
        apps:[]
      };
    },
    filters:{
        formatDateTime(val){
          return moment(val).format('DD-MM-YYYY, h:mm:ss a')
        }
    },
    created() {
        this.getApps();
    },
    methods: {
        getApps(){
          this.loading = true;
            systemApi.getApps().then(response => {
                this.apps = response.data;
                this.loading = false;
            }).catch(error => {
                sysMsgs.getResponseMessage(error.response);
                this.loading = false;
            });
        },
        appStatus(app){
            sysMsgs.getConfirm("Confirme esta acción", "warning").then(result => {
                if (result.value) {
                    this.loading = true
                    app.activo ? (app.activo = 0) : (app.activo = 1);
                    app.user = this.user.email.slice(0, this.user.email.indexOf('@'));
                    systemApi.setApps(app).then(response => {
                        this.loading = false
                        if(response.data) {
                            let arry = this.apps;
                            arry[arry.findIndex(i => i.id == app.id)] = app;
                            arry[arry.findIndex(i => i.id == app.id)].user_actualizacion = app.user
                            arry[arry.findIndex(i => i.id == app.id)].fecha_actualizacion = new Date();
                            this.apps = arry;
                            sysMsgs.getMessage(`${app.titulo} se ha actualizado`, 'success');
                        } else {
                            sysMsgs.getMessage(`Ocurrió un problema al actualizar el sistema ${app.titulo}`, 'warning');
                        }
                    }).catch(error => {
                        sysMsgs.getResponseMessage(error.response);
                        this.loading = false;
                    });
                }
            });  
        }
    }
  };